import React from 'react';
import { DataSetEditHTTPIntegrationHook } from 'apps/sigma2-ui/src/data-wizard/lib/useDataSetEditHTTPIntegration';
import { S2Typography } from 'apps/sigma2-ui/src/components/ui/Typography';
import { Button } from 'apps/sigma2-ui/src/components/ui/Button';
import { Table } from 'apps/sigma2-ui/src/components/ui/Table';
import { SimpleInput } from 'apps/sigma2-ui/src/components/ui/SimpleInput';
import { DataSetSecretSelector } from 'apps/sigma2-ui/src/data-wizard/components/DataSetSecretSelector';
import { SecretReference } from 'libs/end-to-end/src/types/secrets/secret-reference';
import { ReadPatternHook } from 'apps/sigma2-ui/src/lib/hooks/useReadPattern';
import { OrganizationSecretItems } from 'libs/end-to-end/src/types/secrets/organization-secret-items';
import { useLanguage } from 'apps/sigma2-ui/src/lib/hooks/useLanguage';

export const DataSetHTTPConfigurationCustomHeaderListComponent = ({
  httpIntegrationHook,
  organizationId,
  listSecretsPattern,
}: {
  httpIntegrationHook: DataSetEditHTTPIntegrationHook;
  organizationId: string;
  listSecretsPattern: ReadPatternHook<OrganizationSecretItems>;
}) => {
  const language = useLanguage();

  return (
    <>
      <S2Typography
        variant={'headline-3'}
        translatedContent={language.customHeaders()}
      />
      <Button
        behavior={{
          type: 'onClick',
          onClick: () => {
            httpIntegrationHook.setHttpIntegration({
              ...httpIntegrationHook.httpIntegration,
              customHeaderList: [
                ...httpIntegrationHook.httpIntegration.customHeaderList,
                {
                  key: '',
                  value: '',
                },
              ],
            });
          },
        }}
        text={'Add Custom Header'}
      />
      <Table
        items={httpIntegrationHook.httpIntegration.customHeaderList}
        columnDefinitions={[
          {
            id: 'key',
            header: () => <div>Key</div>,
            cell: ({ item, rowIndex }) => (
              <input
                className="form-input"
                type="text"
                key={'key'}
                value={item.key}
                aria-label={'key'}
                onChange={(event) => {
                  const newCustomHeaderList = [
                    ...httpIntegrationHook.httpIntegration.customHeaderList,
                  ];
                  newCustomHeaderList[rowIndex] = {
                    ...newCustomHeaderList[rowIndex],
                    key: event.target.value,
                  };
                  httpIntegrationHook.setHttpIntegration({
                    ...httpIntegrationHook.httpIntegration,
                    customHeaderList: newCustomHeaderList,
                  });
                }}
              />
            ),
          },
          {
            id: 'value',
            header: () => <div>Value</div>,
            cell: ({ item, rowIndex }) => (
              <input
                className="form-input"
                type="text"
                key={'value'}
                value={item.value}
                aria-label={'value'}
                onChange={(event) => {
                  const newCustomHeaderList = [
                    ...httpIntegrationHook.httpIntegration.customHeaderList,
                  ];
                  newCustomHeaderList[rowIndex] = {
                    ...newCustomHeaderList[rowIndex],
                    value: event.target.value,
                  };
                  httpIntegrationHook.setHttpIntegration({
                    ...httpIntegrationHook.httpIntegration,
                    customHeaderList: newCustomHeaderList,
                  });
                }}
              />
            ),
          },
          {
            id: 'actions',
            header: () => <div>Actions</div>,
            cell: ({ rowIndex }) => (
              <Button
                behavior={{
                  type: 'onClick',
                  onClick: () => {
                    const newCustomHeaderList = [
                      ...httpIntegrationHook.httpIntegration.customHeaderList,
                    ];
                    newCustomHeaderList.splice(rowIndex, 1);
                    httpIntegrationHook.setHttpIntegration({
                      ...httpIntegrationHook.httpIntegration,
                      customHeaderList: newCustomHeaderList,
                    });
                  },
                }}
                text={'Remove'}
              />
            ),
          },
        ]}
      />

      <S2Typography
        variant={'headline-3'}
        translatedContent={language.customHeadersSecret()}
      />

      <SimpleInput
        label={'Secret Header Name'}
        value={
          httpIntegrationHook.httpIntegration.customHeadersWithSecrets
            .headerName
        }
        onChange={(value: string) => {
          httpIntegrationHook.setHttpIntegration({
            ...httpIntegrationHook.httpIntegration,
            customHeadersWithSecrets: {
              ...httpIntegrationHook.httpIntegration.customHeadersWithSecrets,
              headerName: value,
            },
          });
        }}
      />

      <DataSetSecretSelector
        label={'Secret Header Value'}
        secretReference={
          httpIntegrationHook.httpIntegration.customHeadersWithSecrets
            .headerSecretReference ?? null
        }
        setSecretReference={(value: SecretReference) => {
          httpIntegrationHook.setHttpIntegration({
            ...httpIntegrationHook.httpIntegration,
            customHeadersWithSecrets: {
              ...httpIntegrationHook.httpIntegration.customHeadersWithSecrets,
              headerSecretReference: value ?? undefined,
            },
          });
        }}
        organizationId={organizationId}
        listSecretsPattern={listSecretsPattern}
      />
    </>
  );
};
